<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { ref } from 'vue'

defineProps<{ value: string; hideMessage?: boolean }>()
const copying = ref<boolean>(false)

/**
 * Copies the passed value to the user's clipboard.
 *
 * @param e the button click event.
 */
const copyValue = async (e: Event, value: string) => {
  copying.value = true
  e.stopPropagation() // Prevent side effects.
  await navigator.clipboard.writeText(value)
  setTimeout(() => (copying.value = false), 1000)
}
</script>

<template>
  <main class="group">
    <slot></slot>
    <aside>
      <el-button class="text-text-component-label invisible group-hover:visible" link @click="copyValue($event, value)">
        <template v-if="copying">
          <Icon icon="material-symbols:check" :width="18" />
        </template>
        <Icon v-else icon="material-symbols:content-copy-outline" :width="18" />
      </el-button>
      <small v-if="copying && !hideMessage">Copied to clipboard!</small>
    </aside>
  </main>
</template>

<style scoped>
main {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-spacing-2xs);
}

aside {
  display: inline-flex;
  align-items: center;
  gap: var(--spacing-spacing-none);
}
</style>
